type Props = {
  readonly size: number;
  readonly iconPath: string;
};

export function IllustrationIcon({ size, iconPath }: Props) {
  return (
    <img
      src={iconPath}
      alt=""
      aria-hidden
      style={{
        width: size,
        height: size,
        objectFit: 'contain',
        display: 'block',
        flexShrink: 0,
      }}
    />
  );
}
